<template>
    <div
        class="px-6 -mx-8 overflow-hidden DateCarousel"
        :class="{ 'opacity-25 pointer-events-none': isLoading }"
    >
        <Carousel :key="hash" :options="{ pageDots: false, cellAlign: 'left' }">
            <div v-for="apt in uniqueDates" :key="apt.isoDate">
                <div
                    class="flex-col justify-center w-16 px-2 mx-1 text-center rounded cell h-28"
                    :class="
                        apt.fullDate === preferredDate
                            ? 'bg-blue-500 text-white'
                            : 'text-blue-500 bg-grey-100'
                    "
                    @click="handleSelect(apt.fullDate)"
                >
                    <p class="mb-3">{{ apt.day }}</p>
                    <p class="small">{{ apt.month }}</p>
                    <p class="text-xl">
                        {{ apt.date }}
                    </p>
                </div>
            </div>
        </Carousel>
    </div>
</template>

<script>
import Carousel from '@/../vue/_base/Carousel.vue';
import { toDateString } from '@/../vue/online-booking/utils/dates';

export default {
    components: {
        Carousel
    },

    props: {
        appointments: {
            type: Array,
            required: true
        },
        preferredDate: {
            type: String,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        uniqueDates() {
            return this.appointments.reduce((acc, current) => {
                const alreadyAdded = acc.find((apt) => apt.isoDate === current.appointmentDate);
                if (alreadyAdded) return acc;
                const day = toDateString(current.appointmentDate, 'ccc');
                const date = toDateString(current.appointmentDate, 'd');
                const month = toDateString(current.appointmentDate, 'MMM');
                const fullDate = toDateString(current.appointmentDate);
                return [
                    ...acc,
                    {
                        day,
                        date,
                        month,
                        fullDate,
                        isoDate: current.appointmentDate,
                        id: current.appointmentId
                    }
                ];
            }, []);
        },
        hash() {
            //  Force Vue to re-render carousel when cells change
            return this.uniqueDates.reduce((acc, current) => {
                return acc + current.appointmentId;
            }, '');
        }
    },

    methods: {
        handleSelect(aptDate) {
            if (!this.isLoading) this.$emit('select', aptDate);
        }
    }
};
</script>

<style scoped>
::v-deep .flickity-prev-next-button {
    width: 22px;
    height: 22px;
}

::v-deep .flickity-viewport {
    @apply overflow-hidden mx-2 !important;
}

::v-deep .flickity-prev-next-button.next {
    right: -20px;
}

::v-deep .flickity-prev-next-button.previous {
    left: -20px;
}

.cell {
    @apply hidden;
}

.flickity-viewport .cell {
    @apply flex;
}
</style>
